import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Range, Direction } from 'react-range';

import { Labels, Track, Thumb } from './styles';

interface RangeSliderProps {
	step: number;
	min: number;
	max: number;
	value: number;
	onChange: (value: number) => void;
	onFinalChange: (value: number) => void;
	labels?: {
		left?: string;
		right?: string;
	};
}

const RangeSlider = ({
	step,
	min,
	max,
	value,
	onChange,
	onFinalChange,
	labels,
}: RangeSliderProps) => (
	<>
		{labels &&
			<Labels>
				{labels.left && <Translate value={labels.left} />}
				{labels.right && <Translate value={labels.right} />}
			</Labels>
		}
		<Range
			step={step}
			min={min}
			max={max}
			values={[value]}
			direction={Direction.Right}
			allowOverlap={false}
			draggableTrack={false}
			disabled={false}
			rtl={false}
			onChange={([value]) => onChange(value)}
			onFinalChange={([value]) => onFinalChange(value)}
			renderTrack={({ props, children }) => (
				<Track {...props}>
					{children}
				</Track>
			)}
			renderThumb={({ props }) => (
				<Thumb {...props} />
			)}
		/>
	</>
);

export default RangeSlider;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/RangeSlider/index.tsx